// extracted by mini-css-extract-plugin
export default {"donation":"MrDUG","avatar":"AsR_O","information":"FabfS","date":"sgnvO","supporter":"s5xjf","message":"_uQAv"};